export default function SvgIconsClick(props) {
    return (
      <svg width={24} height={24} viewBox={"0 0 24 24"} xmlns="http://www.w3.org/2000/svg" fill="#fff" className="bi bi-x-circle-fill" {...props}>
        <rect id="Combined-Shape" fill="currentColor" opacity="0.3" x="6" y="5" width="12" height="18" rx="6"></rect>
        <path d="M11.5,2 L12.5,2 C12.7761424,2 13,2.22385763 13,2.5 L13,5 L11,5 L11,2.5 C11,2.22385763 11.2238576,2 11.5,2 Z" id="Rectangle-2" fill="currentColor"></path>
        <rect id="Rectangle-33" fill="currentColor" x="11" y="16" width="2" height="5" rx="1"></rect>
      </svg>
    )
  }
  
  
